import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.container}>
      <p className="bodySmReg">
        © 2023 OnChain Studios - ©2023 Mattel. - © & ™ Lucasfilm Ltd. - All
        Rights Reserved.
      </p>
    </footer>
  );
}

export default Footer;
